import React from "react";
import "./style.css";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-content">
        <div className="contact-info">Контактная информация</div>
        <div className="contact-info-container">
          <div className="footer-logo-container">
            <a
              className="footer-icon-link"
              href="https://www.instagram.com/motorcar_tuning"
              target="_blank"
              rel="noreferrer"
            >
              <img alt="i" src="/icons/instagram.svg" height="32" width="32" />
            </a>
            <a
              className="footer-icon-link"
              href="https://www.facebook.com/motorcar.tuning/"
              target="_blank"
              rel="noreferrer"
            >
              <img alt="f" src="/icons/facebook.svg" height="32" width="32" />
            </a>
            <a
              className="footer-icon-link"
              href="https://www.youtube.com/channel/UCIJax_AdbOaNm1v2tMoI9Lw"
              target="_blank"
              rel="noreferrer"
            >
              <img alt="y" src="/icons/youtube.svg" height="32" width="32" />
            </a>
          </div>
          <div className="footer-partners-phones-container">
            <p>
              + 38 066 888 66 99 <br />
              <br />
              <a href="https://wa.me/380668886699">Whatsapp</a> /{" "}
              <a href="https://t.me/+380668886699">Telegram</a>
            </p>
          </div>
          <div className="footer-partners-container">
            <p>Работают представительства в городах:</p>
            <p className="font-bold">
              Киев, Харьков, Днепр, Полтава, Белая Церковь, Николаев, Сарны,
              Шостка, Львов
            </p>
            {/*<p>По вопросам предоставления услуг или покупки оборудования писать в іnstagram или <a className="underline" href="tel:+380970733495"> +38 (097) 07 33 495</a> whatsapp/ telegram</p>*/}
          </div>
          <img
            className="footer-icon-link-mms"
            alt="i"
            src="/icons/Logo_MMS.png"
            height="64"
            width="148"
          />
        </div>
      </div>
      <div className="footer-line" />
      <div className="footer-additional-info">
        <div className="footer-additional-info-element">
          <div className="footer-imaged-container">
            <img
              alt="e"
              width="16"
              height="16"
              src="/icons/envelope-footer-icon.svg"
            />
            <div className="footer-imaged-text">motorcar.tuning@gmail.com</div>
          </div>
          <div className="footer-copyright-content">
            <div>ⓒ</div>
            <div className="footer-imaged-text">mc-tuning.ua</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
